import { Tag } from '@chakra-ui/react';
import React from 'react';
import { globalStyles } from 'theme/styles';

interface NullableTagProps {
	value: string | null | undefined;
}

const NullableTag: React.FC<NullableTagProps> = ({ value }) => {
	if (value === '' || value === 'Não Informado') {
		return (
			<Tag
				size='sm'
				color={globalStyles.colors.easyBLUE[200]}
				backgroundColor={globalStyles.colors.easyBLUE[200] + '1A'}
				overflow='hidden'
			>
				Não Informado
			</Tag>
		);
	}

	return <>{value}</>;
};

export default NullableTag;
